(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flash-price"] && !Shopify.designMode) return;
  try {
    function updateFlashPrices(){const format=value=>new Intl.NumberFormat('en-ZA',{style:'currency',currency:'ZAR'}).format(value/100);document.querySelectorAll('[data-flash-price]').forEach(el=>{const price=Number(el.dataset.amount);const active=Date.now()<Date.parse(el.dataset.end);const saving=Math.round(price*.15);el.querySelector('[data-regular-price]').textContent=format(price);el.querySelector('[data-regular-price]').hidden=!active;el.querySelector('[data-sale-price]').textContent=format(active?price-saving:price);el.querySelector('[data-price-saving]').textContent=el.dataset.saveLabel+' '+format(saving)+' · '+el.dataset.offLabel;el.querySelector('[data-price-saving]').hidden=!active;});}updateFlashPrices();document.addEventListener('ns:prices',updateFlashPrices);document.addEventListener('shopify:section:load',updateFlashPrices);setInterval(updateFlashPrices,1000);
  } catch(e) { console.error(e); }
})();

})();
